// extracted by mini-css-extract-plugin
export default {"form":"BiometricsModal_form__u7u49","body":"BiometricsModal_body__LWEsP","background":"BiometricsModal_background__bJcVZ"};